@if ((this.client$ | async)) {
  @if ((this.ondernemingen$ | async)?.length) {
    @if (!(this.administrations$ | async)?.length) {
      <div style="width: 75%">
        <snelstart-ui-alert type="info">
          Voor het inlezen van een administratie is het noodzakelijk dat er bij de klantinstellingen een of meer
          Snelstart-administraties aan de klant gekoppeld zijn.<br/>
          Op dit moment zijn er bij deze klant geen administraties gekoppeld.
          <div class="space10"></div>
          Ga naar de klantenlijst, selecteer de klant en maak bij 'Instellingen' een keuze welke
          SnelStart-administratie(s) je wilt koppelen.
          <div class="space20"></div>
          Let op: koppelen is alleen mogelijk als de administratie 'RGS Ready' is!
        </snelstart-ui-alert>
      </div>
    } @else {
      <div style="width: 75%">
        <snelstart-ui-alert type="info">
          Bij de klantinstellingen is er een koppeling met een Snelstart administratie. Je kunt de gegevens inlezen in de
          aangifte als de <strong>administratie 'RGS Ready'</strong> is. Maak je na het inlezen wijzigingen in de
          administratie, dan worden deze NIET automatisch opnieuw ingelezen in de aangifte. Je kunt er wel alsnog zelf
          voor kiezen de nieuwe gegevens in te lezen. Zie 'Toelichting'.<br/>
          <br/>
          @if ((this.dataService.heeftSamenwerkingsverbandWuo | async)) {
            <p class="pt-1">Er is sprake van een <strong>samenwerkingsverband (vennootschap onder firma/maatschap)</strong>. Het inlezen van de
              administratie heeft dan alleen zin als er gekozen is voor het invullen van de cijfers op
              samenwerkingsniveau (zie onderdeel 'Onderneming').</p>
          }
        </snelstart-ui-alert>
      </div>
      <div class="pt-2">
        <div [formGroup]="formGroup">
          <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-select-form-control [options]="(this.administrationOptions$ | async) ?? []"
                                              id="administrationId"
                                              formControlName="administrationId"
                                              class="custom-input-250"
                                              label="Selecteer administratie"
            >
            </snelstart-ui-select-form-control>
            <snelstart-ui-button [config]="this.removeOndernemingAdministrationButtonConfiguration"
                                 id="removeOndernemingAdministrationButton"
                                 class="col-auto pt-3"
                                 icon="trash"
                                 iconType="light"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
          @if ((this.selectedAdministration$ | async)) {
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              @if (!(this.selectedAdministration$ | async)?.providerId) {
                <div>
                  <snelstart-ui-button [config]="this.importSnelStartBalanceButtonConfiguration"
                                       type="primary"
                                       class="custom-input-250"
                                       icon="arrow-up-from-dotted-line">
                    Cijfers {{ (this.incomeTax$ | async)?.aangifte?.aangifteJaar }} inlezen
                  </snelstart-ui-button>
                </div>
              } @else if ((this.identityProviderStatus$ | async)?.authenticated) {
                <div>
                  <snelstart-ui-button [config]="this.importBalanceProviderBalanceButtonConfiguration"
                                       [disabled]="!(this.identityProviderStatus$ | async)?.authenticated"
                                       type="primary"
                                       class="custom-input-250"
                                       icon="arrow-up-from-dotted-line">
                    Cijfers {{ (this.incomeTax$ | async)?.aangifte?.aangifteJaar }} inlezen
                  </snelstart-ui-button>
                </div>
              }
            </div>
          }
          <div style="width: 75%; padding-top: 50px">
            <snelstart-ui-alert type="warning">
              <strong>Let op: De beginbalans worden niet ingelezen!</strong><br/>
              Bij het inlezen worden uitsluitend de resultatenrekening en balans per einde boekjaar
              (meestal 31-12) overgenomen uit de administratie.
            </snelstart-ui-alert>
          </div>
        </div>
      </div>
    }
  } @else {
    Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
  }
}
